import { ContactSource, ContactStatus } from '@dev/ee-api/ee-api-models';

import i18n from '../../../i18n';

export const contactStatuses = [
    { translationKey: 'active', enumValue: ContactStatus.Active },
    { translationKey: 'engaged', enumValue: ContactStatus.Engaged },
    { translationKey: 'transactional', enumValue: ContactStatus.Transactional },
    { translationKey: 'bounced', enumValue: ContactStatus.Bounced },
    { translationKey: 'unsubscribed', enumValue: ContactStatus.Unsubscribed },
    { translationKey: 'abuse', enumValue: ContactStatus.Abuse },
    { translationKey: 'inactive', enumValue: ContactStatus.Inactive },
    { translationKey: 'stale', enumValue: ContactStatus.Stale },
    { translationKey: 'notconfirmed', enumValue: ContactStatus.NotConfirmed },
];

export const contactStatusesTranslated = [
    { translationKey: i18n.t('active'), enumValue: ContactStatus.Active },
    { translationKey: i18n.t('transactional'), enumValue: ContactStatus.Transactional },
    { translationKey: i18n.t('engaged'), enumValue: ContactStatus.Engaged },
    { translationKey: i18n.t('notconfirmedspace'), enumValue: ContactStatus.NotConfirmed },
    { translationKey: i18n.t('invalid'), enumValue: ContactStatus.Bounced },
    { translationKey: i18n.t('unsubscribed'), enumValue: ContactStatus.Unsubscribed },
    { translationKey: i18n.t('complained'), enumValue: ContactStatus.Abuse },
    { translationKey: i18n.t('inactive'), enumValue: ContactStatus.Inactive },
    { translationKey: i18n.t('stale'), enumValue: ContactStatus.Stale },
];

export const contactSourceTranslated = {
    [ContactSource.DeliveryApi]: i18n.t('deliveryapi'),
    [ContactSource.ManualInput]: i18n.t('manualinput'),
    [ContactSource.FileUpload]: i18n.t('fileupload'),
    [ContactSource.WebForm]: i18n.t('webform'),
    [ContactSource.ContactApi]: i18n.t('contactapi'),
    [ContactSource.VerificationApi]: i18n.t('verificationapi'),
    [ContactSource.FileVerificationApi]: i18n.t('fileverificationapi'),
};
